import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { ACHIEVEMENTS } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={ACHIEVEMENTS} id={id} />;
}

export const Route = createFileRoute("/_app/departments/achievements/$id")({
  component: Edit,
});
